import { CellStyle } from 'ag-grid-community'
import { colorPalette } from '../../../style/colorPalette'

// グレーアウトするセル（編集不可セル・値を表示しないセル）の共通背景色。
export const GRAYED_OUT_STYLE: CellStyle = {
  backgroundColor: colorPalette.monotone[1],
}
